export * from "./constructNpmPackage.js";
export { getNamespaceExport, type ResolvedNaming, resolveNaming } from "./getNamespaceExport.js";
